const LOGIC = 0
const ABSTRACT = 1
const KNOWING = 2
const CENTERING = 3
const INTEGRATION = 4
const DEFENSE = 5
const EGO = 6

export default { LOGIC, ABSTRACT, KNOWING, CENTERING, INTEGRATION, DEFENSE, EGO }
